<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="ShiftPoliciesForm" (ngSubmit)="Validate(ShiftPoliciesForm)" #ShiftPoliciesForm="ngForm"
        novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Shift Policy
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-2">
                        <div class="col-md-2 align-self-center">
                            <label for="RuleName" class="form-label text-label-dark">Policy Name :</label>
                        </div>
                        <div class="col-md-5">
                            <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                id="RuleName" name="RuleName" [(ngModel)]="ShiftRuleDetail.RuleName"
                                #RegularizationRuleTitle="ngModel" maxlength="100" required>
                            <div class="invalid-feedback">
                                Please Enter Policy Name!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-2 align-self-center">
                            <label for="AttendanceType" class="form-label text-label-dark">Attendance Type :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" (change)="AttendanceTypeChange()"
                                        value='hour' name="AttendanceType" [(ngModel)]="ShiftRuleDetail.AttendanceType"
                                        [ngModelOptions]="{standalone: true}">
                                    Hour
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" (change)="AttendanceTypeChange()"
                                        value='time' name="AttendanceType" [(ngModel)]="ShiftRuleDetail.AttendanceType"
                                        [ngModelOptions]="{standalone: true}">
                                    Time
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-2 align-self-center">
                            <label class="form-label text-label-dark">Full Day Duration : </label>
                        </div>
                        <div class="col-md-auto">
                            <!-- <input type="time" timeformat="24h" class="form-control text-label-light"
                                placeholder="Ex. 10:00" id="Duration" name="Duration" min="00:00" max="23:59"
                                [(ngModel)]="ShiftRuleDetail.Duration" #Duration="ngModel" required> -->
                            <ngb-timepicker name="Duration" type="time" [(ngModel)]="ShiftRuleDetail.DurationObj"
                                #Duration="ngModel" (change)="timeFormate($event,'Duration')"
                                [ngModelOptions]="{standalone: true}" required></ngb-timepicker>
                            <div class="invalid-feedback">
                                Please enter duration!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">hours</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.Message24hr"></i>
                        </div>

                    </div>
                    <div class="row mb-2">
                        <div class="col-md-2 align-self-center">
                            <label class="form-label text-label-dark">Half Day Duration : </label>
                        </div>
                        <div class="col-md-auto">
                            <!-- <input type="time" timeformat="24h" class="form-control text-label-light"
                                placeholder="Ex. 10:00" id="HalfDayDuration" name="HalfDayDuration" min="00:00"
                                max="23:59" [(ngModel)]="ShiftRuleDetail.HalfDayDuration" #HalfDayDuration="ngModel"
                                required> -->
                            <ngb-timepicker name="HalfDayDuration" type="time"
                                [(ngModel)]="ShiftRuleDetail.HalfDayDurationObj" #HalfDayDuration="ngModel"
                                [ngModelOptions]="{standalone: true}" (change)="timeFormate($event,'HalfDayDuration')"
                                required></ngb-timepicker>
                            <div class="invalid-feedback">
                                Please enter duration!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">hours</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.Message24hr"></i>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-2 align-self-center">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="OTApplicable" id="OTApplicable"
                                    [(ngModel)]="ShiftRuleDetail.OTApplicable">
                                <label class="form-check-label text-label-dark" for="SelectAll">
                                    OT Applicable
                                </label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='internal' name="OTApplicableIn"
                                        [(ngModel)]="ShiftRuleDetail.OTApplicableIn"
                                        [disabled]="!ShiftRuleDetail.OTApplicable"
                                        [ngModelOptions]="{standalone: true}">
                                    Internal
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" value='client' name="OTApplicableIn"
                                        [(ngModel)]="ShiftRuleDetail.OTApplicableIn"
                                        [disabled]="!ShiftRuleDetail.OTApplicable"
                                        [ngModelOptions]="{standalone: true}">
                                    Client
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-5 align-self-center">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="MarkWeekOffAsPresent"
                                    id="MarkWeekOffAsPresent" [(ngModel)]="ShiftRuleDetail.MarkWeekOffAsPresent">
                                <label class="form-check-label text-label-dark" for="MarkWeekOffAsPresent">
                                    Mark Week Off As Present
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-5 align-self-center">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="IsMarkWeekoff_PresentApplicable"
                                    id="IsMarkWeekoff_PresentApplicable"
                                    (change)="MarkWeekoffand('P',$event)"
                                    [(ngModel)]="ShiftRuleDetail.IsMarkWeekoff_PresentApplicable">
                                <label class="form-check-label text-label-dark" for="IsMarkWeekoff_PresentApplicable">
                                    Mark Weekoff Present Applicable
                                </label>
                            </div>
                        </div>
                        <div class="col-md-5 align-self-center">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="MarkWeekoffandPresentBoth"
                                    id="MarkWeekoffandPresentBoth"
                                    (change)="MarkWeekoffand('B',$event)"
                                    [(ngModel)]="ShiftRuleDetail.MarkWeekoffandPresentBoth">
                                <label class="form-check-label text-label-dark" for="MarkWeekoffandPresentBoth">
                                    Mark Weekoffand Present Both
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-header">
                    Grace Period
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-2">
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark" style="padding-right: 18px;">First check-in late
                                by : </label>
                        </div>
                        <div class="col-md-auto">
                            <!-- <input type="time" class="form-control text-label-light" placeholder="Ex. 10:00"
                                id="FirstCheckInLate" name="FirstCheckInLate" min="00:00" max="23:59"
                                [(ngModel)]="ShiftRuleDetail.FirstCheckInLate" #FirstCheckInLate="ngModel"
                                [disabled]="ShiftRuleDetail.AttendanceType != 'time'" required> -->

                            <ngb-timepicker name="FirstCheckInLate" type="time"
                                [(ngModel)]="ShiftRuleDetail.FirstCheckInLateObj" #FirstCheckInLate="ngModel"
                                [ngModelOptions]="{standalone: true}"
                                [disabled]="ShiftRuleDetail.AttendanceType != 'time'" required></ngb-timepicker>

                            <div class="invalid-feedback">
                                Please enter first check in late!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">hours</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.Message24hr"></i>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">Late check-out early by : </label>
                        </div>
                        <div class="col-md-auto">
                            <!-- <input type="time" class="form-control text-label-light" placeholder="Ex. 10:00"
                                id="LastCheckOutEarly" name="LastCheckOutEarly" min="00:00" max="23:59"
                                [(ngModel)]="ShiftRuleDetail.LastCheckOutEarly" #LastCheckOutEarly="ngModel"
                                [disabled]="ShiftRuleDetail.AttendanceType != 'time'" required> -->

                            <ngb-timepicker name="LastCheckOutEarly" type="time"
                                [(ngModel)]="ShiftRuleDetail.LastCheckOutEarlyObj" #LastCheckOutEarly="ngModel"
                                [ngModelOptions]="{standalone: true}"
                                [disabled]="ShiftRuleDetail.AttendanceType != 'time'" required></ngb-timepicker>
                            <div class="invalid-feedback">
                                Please enter last check out early!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">hours</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.Message24hr"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-header">
                    Grace Period For Duty Duration
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-2">
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark" style="padding-right: 18px;">Grace period for duty
                                duration : </label>
                        </div>
                        <div class="col-md-auto">
                            <ngb-timepicker name="GracePeriodForDutyDurationObj" type="time"
                                [(ngModel)]="ShiftRuleDetail.GracePeriodForDutyDurationObj"
                                #GracePeriodForDutyDurationObj="ngModel" [ngModelOptions]="{standalone: true}"
                                required></ngb-timepicker>

                            <div class="invalid-feedback">
                                Please enter grace period for duty duration!
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-header">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="Deviation" id="Deviation"
                            [(ngModel)]="ShiftRuleDetail.Deviation">
                        <label class="form-check-label" for="Deviation">
                            Deduct When
                        </label>
                    </div>
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-2">
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">
                                <input class="form-check-input" type="radio" [value]=false
                                    name="IsDeviationOccurMultiplyOf"
                                    [(ngModel)]="ShiftRuleDetail.IsDeviationOccurMultiplyOf"
                                    [ngModelOptions]="{standalone: true}" [disabled]="!ShiftRuleDetail.Deviation"
                                    required>
                                Deviation are more than : </label>
                        </div>
                        <div class="col-md-auto" style="width: 115px;">
                            <input type="text" maxlength="5" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                class="form-control text-label-light" placeholder="Ex. 10" id="DeviationMoreThan"
                                name="DeviationMoreThan" [(ngModel)]="ShiftRuleDetail.DeviationMoreThan"
                                #DeviationMoreThan="ngModel"
                                [disabled]="!ShiftRuleDetail.Deviation || ShiftRuleDetail.IsDeviationOccurMultiplyOf"
                                required>
                            <div class="invalid-feedback">
                                Please enter deviation more than!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">time(s) per</label>
                        </div>
                        <div class="col-md-3">
                            <select class="form-select text-label-light" aria-label="DeviationMoreThanPeriod"
                                placeholder="DeviationMoreThanPeriod" title="DeviationMoreThanPeriod"
                                name="DeviationMoreThanPeriod" [(ngModel)]="ShiftRuleDetail.DeviationMoreThanPeriod"
                                disabled #DeviationMoreThanPeriod="ngModel" required>
                                <option disabled [value]=null>--Select Period--</option>
                                @for (PeriodType of common.PeriodTypes; track PeriodType.Name;) {
                                <option *ngIf="PeriodType.Name == 'Month'" [value]=PeriodType.Value>
                                    {{PeriodType.Name}}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">
                                <input class="form-check-input" type="radio" [value]=true
                                    name="IsDeviationOccurMultiplyOf"
                                    [(ngModel)]="ShiftRuleDetail.IsDeviationOccurMultiplyOf"
                                    [ngModelOptions]="{standalone: true}" [disabled]="!ShiftRuleDetail.Deviation"
                                    required>
                                Deviation occur on mulitiple of : </label>
                        </div>
                        <div class="col-md-auto" style="width: 115px;">
                            <input type="text" maxlength="3" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                [ngClass]="{'ng-invalid': common.parseFloat(ShiftRuleDetail.DeviationOccurMultiplyOf) > DeviationoccurMax}"
                                class="form-control text-label-light" placeholder="Ex. 10" id="DeviationOccurMultiplyOf"
                                name="DeviationOccurMultiplyOf" [(ngModel)]="ShiftRuleDetail.DeviationOccurMultiplyOf"
                                #DeviationOccurMultiplyOf="ngModel"
                                [disabled]="!ShiftRuleDetail.Deviation || !ShiftRuleDetail.IsDeviationOccurMultiplyOf"
                                required>
                            <div class="invalid-feedback">
                                Please enter deviation occur on mulitiple of maximum {{DeviationoccurMax}}!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">day's in a</label>
                        </div>
                        <div class="col-md-3">
                            <select class="form-select text-label-light" aria-label="DeviationOccurMultiplyOFPeriod"
                                placeholder="DeviationOccurMultiplyOFPeriod" title="DeviationOccurMultiplyOFPeriod"
                                name="DeviationOccurMultiplyOFPeriod" (change)="SetMaxDay()"
                                [(ngModel)]="ShiftRuleDetail.DeviationOccurMultiplyOFPeriod" disabled
                                #DeviationOccurMultiplyOFPeriod="ngModel" required>
                                <option disabled [value]=null>--Select Period--</option>
                                @for (PeriodType of common.PeriodTypes; track PeriodType.Name;) {
                                <option *ngIf="PeriodType.Name == 'Month'" [value]=PeriodType.Value>
                                    {{PeriodType.Name}}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">Deduct </label>
                        </div>
                        <div class="col-md-auto" style="width: 180px;">
                            <!-- <input type="text" maxlength="5" pattern="^[0-9]\d*$"
                                (keypress)="common.NumberOnly($event,common.allowDot(ShiftRuleDetail.LeaveDeductDay))"
                                [ngClass]="{'ng-invalid': common.parseFloat(ShiftRuleDetail.LeaveDeductDay) > 365}"
                                class="form-control text-label-light" placeholder="Ex. 10" id="LeaveDeductDay"
                                name="LeaveDeductDay" [(ngModel)]="ShiftRuleDetail.LeaveDeductDay"
                                #LeaveDeductDay="ngModel" [disabled]="!ShiftRuleDetail.Deviation" required> -->
                            <select class="form-select text-label-light" aria-label="LeaveDeductDay"
                                placeholder="LeaveDeductDay" title="LeaveDeductDay" name="LeaveDeductDay"
                                [(ngModel)]="ShiftRuleDetail.LeaveDeductDay" (change)="ChangeLeaveDeductDay()"
                                [disabled]="!ShiftRuleDetail.Deviation" #LeaveDeductDay="ngModel" required>
                                <option [value]=0>No Deduct</option>
                                <option [value]=1>1 - Full Day</option>
                                <option [value]=0.5>0.5 - Half Day</option>
                            </select>
                            <div class="invalid-feedback">
                                Please enter leave deduct day maximum 365!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center text-label-dark">
                            <label class="form-label">day's from following leave balance</label>
                        </div>
                        <div class="col-md-3">
                            <select class="form-select text-label-light" aria-label="LeaveDeductTypeObj"
                                placeholder="LeaveDeductTypeObj" title="LeaveDeductTypeObj" name="LeaveDeductTypeObj"
                                [(ngModel)]="ShiftRuleDetail.LeaveDeductTypeObj"
                                [disabled]="!ShiftRuleDetail.Deviation || ShiftRuleDetail.LeaveDeductDay == 0"
                                #LeaveDeductTypeObj="ngModel" required>
                                <option disabled [value]=null>--Select Leave--</option>
                                <option *ngFor="let LeaveType of LeaveTypes" [value]=LeaveType.LeaveMasterID>
                                    {{LeaveType.LeaveName}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-header">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="ShiftMargin" id="ShiftMargin"
                            [(ngModel)]="ShiftRuleDetail.ShiftMargin">
                        <label class="form-check-label" for="ShiftMargin">
                            Shift Margin
                        </label>
                    </div>
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-2">
                        <div class="col-md-3 align-self-center" style="width: 220px;">
                            <label class="form-label text-label-dark">Hours before the shift start : </label>
                        </div>
                        <div class="col-md-auto">
                            <!-- <input type="time" class="form-control text-label-light" placeholder="Ex. 10:00"
                                id="HourBeforeShiftStart" name="HourBeforeShiftStart" min="00:00" max="23:59"
                                [(ngModel)]="ShiftRuleDetail.HourBeforeShiftStart"
                                [disabled]="!ShiftRuleDetail.ShiftMargin" #HourBeforeShiftStart="ngModel" required> -->

                            <ngb-timepicker name="HourBeforeShiftStart" type="time"
                                [(ngModel)]="ShiftRuleDetail.HourBeforeShiftStartObj" #HourBeforeShiftStart="ngModel"
                                [ngModelOptions]="{standalone: true}" [disabled]="!ShiftRuleDetail.ShiftMargin"
                                required></ngb-timepicker>
                            <div class="invalid-feedback">
                                Please enter hour before shift start!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center text-label-dark">
                            <label class="form-label">hours</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.Message24hr"></i>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-3 align-self-center" style="width: 220px;">
                            <label class="form-label text-label-dark">Hours after the shift end : </label>
                        </div>
                        <div class="col-md-auto">
                            <!-- <input type="time" class="form-control text-label-light" placeholder="Ex. 10:00"
                                id="HourAfterShiftStart" name="HourAfterShiftStart" min="00:00" max="23:59"
                                [(ngModel)]="ShiftRuleDetail.HourAfterShiftStart"
                                [disabled]="!ShiftRuleDetail.ShiftMargin" #HourAfterShiftStart="ngModel" required> -->

                            <ngb-timepicker name="HourAfterShiftStart" type="time"
                                [(ngModel)]="ShiftRuleDetail.HourAfterShiftStartObj" #HourAfterShiftStart="ngModel"
                                [ngModelOptions]="{standalone: true}" [disabled]="!ShiftRuleDetail.ShiftMargin"
                                required></ngb-timepicker>

                            <div class="invalid-feedback">
                                Please enter hour after shift end!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">hours</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.Message24hr"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-header">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="Insentive" id="Insentive"
                            [(ngModel)]="ShiftRuleDetail.Insentive">
                        <label class="form-check-label" for="Insentive">
                            Incentive
                        </label>
                    </div>
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-2">
                        <div class="col-md-3 align-self-center" style="width: 220px;">
                            <label class="form-label text-label-dark">Attendance greater than : </label>
                        </div>
                        <div class="col-md-auto" style="width: 115px;">
                            <input type="text" maxlength="3" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                [ngClass]="{'ng-invalid': common.parseFloat(ShiftRuleDetail.AttendanceGreaterThan) > 365}"
                                class="form-control text-label-light" placeholder="Ex. 01" id="AttendanceGreaterThan"
                                name="AttendanceGreaterThan" [(ngModel)]="ShiftRuleDetail.AttendanceGreaterThan"
                                [disabled]="!ShiftRuleDetail.Insentive" #AttendanceGreaterThan="ngModel" required>
                            <div class="invalid-feedback">
                                Please enter attendance greater than! maximum 365
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">Days</label>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-3 align-self-center" style="width: 220px;">
                            <label class="form-label text-label-dark">Occurrence on mulitiple of : </label>
                        </div>
                        <div class="col-md-auto" style="width: 115px;">
                            <input type="text" maxlength="5" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                class="form-control text-label-light" placeholder="Ex. 01"
                                id="AttendanceOccurMultiplyOf" name="AttendanceOccurMultiplyOf"
                                [(ngModel)]="ShiftRuleDetail.AttendanceOccurMultiplyOf"
                                [disabled]="!ShiftRuleDetail.Insentive" #AttendanceOccurMultiplyOf="ngModel" required>
                            <div class="invalid-feedback">
                                Please enter attendance occur multiply of!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">Time(s) in</label>
                        </div>
                        <div class="col-md-2">
                            <select class="form-select text-label-light" aria-label="AttendanceOccurMultiplyOfPeriod"
                                placeholder="AttendanceOccurMultiplyOfPeriod" title="AttendanceOccurMultiplyOfPeriod"
                                name="AttendanceOccurMultiplyOfPeriod"
                                [(ngModel)]="ShiftRuleDetail.AttendanceOccurMultiplyOfPeriod"
                                [disabled]="!ShiftRuleDetail.Insentive" #AttendanceOccurMultiplyOfPeriod="ngModel"
                                required>
                                <option disabled [value]=null>--Select Period--</option>
                                <option *ngFor="let PeriodType of common.PeriodTypes" [value]=PeriodType.Value>
                                    {{PeriodType.Name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-0 ps-5">
                <div class="col-md-2" style="width: 135px;">
                    <label for="EmpType" class="form-label text-label-dark">Employee Type :</label>
                </div>
                <div class="col-md-5">
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                            *ngIf="(this.ShiftRuleDetail.ESS_ShiftRuleID == 0) || (this.ShiftRuleDetail.ESS_ShiftRuleID > 0 && common.ToLowerCase(ShiftRuleDetail.EmpType) == 'front')">
                            <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                [(ngModel)]="ShiftRuleDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                (change)="GetApplicability()" [disabled]="ShiftRuleDetail.ESS_ShiftRuleID > 0" required>
                            Front Office
                        </label>
                        <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                            *ngIf="(this.ShiftRuleDetail.ESS_ShiftRuleID == 0) || (this.ShiftRuleDetail.ESS_ShiftRuleID > 0 && common.ToLowerCase(ShiftRuleDetail.EmpType) == 'back')">
                            <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                [(ngModel)]="ShiftRuleDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                (change)="GetApplicability()" [disabled]="ShiftRuleDetail.ESS_ShiftRuleID > 0" required>
                            Back Office
                        </label>
                    </div>
                </div>
            </div>
            <div class="row m-0 ps-5">
                <div class="col-md-2" style="width: 135px;">
                    <label for="DefaultRule" class="form-label text-label-dark">Default Rule :</label>
                </div>
                <div class="col-md-5">
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=true name="DefaultRule"
                                [(ngModel)]="ShiftRuleDetail.DefaultRule" [ngModelOptions]="{standalone: true}">
                            Yes
                        </label>
                        <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=false name="DefaultRule"
                                [(ngModel)]="ShiftRuleDetail.DefaultRule" [ngModelOptions]="{standalone: true}">
                            No
                        </label>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="ShiftRuleDetail.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                                        [disabled]="Applicability.WebESSApplicabilityMasterID == 0 && ShiftRuleDetail.DefaultRule">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && ShiftRuleDetail.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.ShiftRuleDetail.ESS_ShiftRuleID == 0) || (this.common.PageRight.IsEdit && this.ShiftRuleDetail.ESS_ShiftRuleID > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>